<template>
  <div class="col">
    <Calendar-Filters
      :days="getDays"
      @change-week="(data) => $emit('change-week', data)"
      @onSelectedDate="onSelectedDate"
    />
    <div class="row no-gutters w-100 mt-5">
      <CalendarColumn
        v-for="day in getDays"
        :key="day.id"
        :day="day"
        @select-schedule="(data) => $emit('select-schedule', data)"
      />
    </div>
  </div>
</template>

<script>
import CalendarFilters from './WeekCalendarFilters';
import CalendarColumn from './WeekCalendarColumn';
import moment from 'moment';

export default {
  meta: {
    description: 'Componente común, calendario de Espacios Disponible.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    CalendarColumn,
    CalendarFilters,
  },
  props: {
    days: {
      type: Array,
      required: true,
      default: () => [
        {
          date: new Date(),
          hasError: false,
          errorMsg: 'Fecha Incumplimiento',
          scheduleList: [{ id: '1', text: '', isSelected: false }],
        },
      ],
      meta: {
        description: 'Propiedad para los días del calendario',
        example: '[4, 8, 15, 16, 23, 42]',
      },
    },
  },
  methods: {
    onSelectedDate(date) {
      this.$emit('onSelectedDate', moment(date).format());
    },
    getDayName(date) {
      let dayName = moment(date).format('ddd');
      dayName = dayName.replace('.', '');

      return dayName;
    },
    getDayNumber(date) {
      return moment(date).format('DD');
    },
    getSchedule(schedules) {
      let stopAt = 7;
      const resultList = [];

      for (let i = 0; i < stopAt; i++) {
        if (i < schedules.length) resultList.push(schedules[i]);
        else resultList.push({ text: '', isSelected: false });
      }

      return resultList;
    },
  },
  computed: {
    getDays() {
      return this.days.map((day) => {
        day.name = this.getDayName(day.date);
        day.dayNumber = this.getDayNumber(day.date);
        day.id = day.dayNumber;
        day.schedules = this.getSchedule(day.scheduleList);

        return day;
      });
    },
  },
};
</script>

<style scoped></style>
